import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu"
import { DropdownMenuTrigger } from "@radix-ui/react-dropdown-menu"
import {
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/atoms/DropDown/dropdown"

export const DropdownMenu = DropdownMenuPrimitive.Root
export { DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator }
